import { render, staticRenderFns } from "./OrganizationFilter.vue?vue&type=template&id=180b998a&scoped=true&"
import script from "./OrganizationFilter.vue?vue&type=script&lang=ts&"
export * from "./OrganizationFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180b998a",
  null
  
)

export default component.exports